import dashboardSaga from "./dashboard.saga";
import salesForecastSaga from "./sales-forecast.saga";
import salesTargetSaga from "./sales-target.saga";

export default [dashboardSaga, salesForecastSaga, salesTargetSaga];
